module.exports = __webpack_public_path__ + "static/media/product_list_3.c0973bd9.png";